export default function () {
  return {
    competitions: [],
    userCompetitions: [],
    entities: [],
    selectedCompetitions: []
  }
}
